import { render, staticRenderFns } from "./PromoEditing.vue?vue&type=template&id=98e02362"
import script from "./PromoEditing.vue?vue&type=script&lang=js"
export * from "./PromoEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports